import { ValidateRoute } from "../../routes/ValidRoute";
import Buildings from "../Buildings/Buildings";
import BuildingsUpdate from "../BuildingsUpdate/BuildingsUpdate";
import BuildingsAdd from "../BuildingsAdd/BuildingsAdd";

/* ------ Building Data Routes ------ */
export const ROUTE_REGION_AND_BUILDING_DATA = {
    plain: 'Region-and-Building-Data',
    withSlash: '/Region-and-Building-Data',
    title: 'Region and Building Data',
    module: 'ROUTE_REGION_AND_BUILDING_DATA'
};
export const ROUTE_ADD_BUILDING = {
    plain: 'Add-Building',
    withSlash: '/Add-Building',
    title: 'Add a Building',
    module: 'ROUTE_REGION_AND_BUILDING_DATA'
}
export const ROUTE_EDIT_BUILDING = {
    plain: 'Edit-Building',
    withSlash: '/Edit-Building',
    title: 'Edit Building',
    module: 'ROUTE_REGION_AND_BUILDING_DATA',
    edit: true
}
/* ------ (end) Building Data Routes ------ */

export const buildingRoutes = [
    {
        path: ROUTE_REGION_AND_BUILDING_DATA.plain,
        element: <ValidateRoute route={ROUTE_REGION_AND_BUILDING_DATA}><Buildings /></ValidateRoute>,
    },
    {
        path: ROUTE_EDIT_BUILDING.plain,
        element: <ValidateRoute route={ROUTE_EDIT_BUILDING}><BuildingsUpdate /></ValidateRoute>
    },
    {
        path: ROUTE_ADD_BUILDING.plain, // accept incoming changes
        element: <ValidateRoute route={ROUTE_ADD_BUILDING}>
            <BuildingsAdd />
        </ValidateRoute>
    },
];